export default "__VITE_ASSET__85df7064__"